module.exports = function() {
  return new Worker(__webpack_public_path__ + "68193fbe5a5f6e0ffc1a.worker.js");
};